import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHighlighter12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconHighlighter12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m9.089 2.422.496.498c.368.368.392.958.056 1.355l-3.324 3.93-2.502-2.508 3.921-3.33a.997.997 0 0 1 1.353.055m-5.8 4.163-.506 1.349 1.303 1.305 1.346-.506zM7.09 1.603a1.995 1.995 0 0 1 2.704.111l.496.498c.736.737.784 1.915.112 2.71L7.006 8.94c-.22.26-.503.46-.821.58l-1.748.657a1 1 0 0 1-.631.024l-.53.488c-.25.23-.578.359-.918.359-1.221 0-1.822-1.49-.943-2.34l.434-.419a1 1 0 0 1-.001-.706l.656-1.752c.12-.32.32-.603.579-.823zm-4.6 7.454.517.518-.407.376a.36.36 0 0 1-.492-.523zm5.163 1.023a.5.5 0 1 0 0 1h2.965a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHighlighter12);
